module.exports = __webpack_public_path__ + "static/media/smoothsole-3.b332b4da.jpg";